/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PeriodicBackgroundJobPayloadBase extends models.BackgroundJobPayloadBase {
    getFixupPrototypeFunction() { return PeriodicBackgroundJobPayloadBase.fixupPrototype; }

    static newInstance(model: Partial<PeriodicBackgroundJobPayloadBase>): PeriodicBackgroundJobPayloadBase {
        let obj = Object.assign(new PeriodicBackgroundJobPayloadBase(), model);
        PeriodicBackgroundJobPayloadBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PeriodicBackgroundJobPayloadBase>): PeriodicBackgroundJobPayloadBase {
        if (!model) return null;
        return PeriodicBackgroundJobPayloadBase.newInstance(<PeriodicBackgroundJobPayloadBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PeriodicBackgroundJobPayloadBase) {
        if (!obj) return;

        models.PeriodicBackgroundJobPayloadBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PeriodicBackgroundJobPayloadBase): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PeriodicBackgroundJobPayloadBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
